import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./Metaverse.css";
import ServiceFooter from "../../ServiceFooter";
import { useState } from "react";
import { useCases } from "./data";
import { motion, AnimatePresence } from "framer-motion";

const classNames = ["mts_st_one", "mts_st_two", "mts_st_three", "mts_st_four"];

const Metaverse = () => {
  const [cards, setCards] = useState(useCases);

  const handleNext = () => {
    const updated = [...cards.slice(1), cards[0]];
    setCards(updated);
  };

  const handlePrev = () => {
    const updated = [
      cards[cards.length - 1],
      ...cards.slice(0, cards.length - 1),
    ];
    setCards(updated);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Metaverse Development company</title>

        <meta name="title" content=" Metaverse Development company" />
        <meta
          name="description"
          content="Experience Limitless Possibilities with Beleaf Technology - A Premier Metaverse Development Company. Dive into a virtual reality-based digital universe where imagination knows no bounds. Discover our cutting-edge solutions that blend VR, AR, and immersive technologies. Join the metaverse revolution and redefine your digital experience with Beleaf Technology today!"
        />
        <meta property="og:title" content=" Metaverse Development company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/metaverse-development-company"
        />
      </Helmet>

      <main className="mts_main">
        {/* hero */}
        <article className="mts_hero mts_mb_120">
          <div className="primary__landing__container">
            <h1 className="mts_title">Metaverse Development Company</h1>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="mts_btn mt-4"
            >
              Get Free Consultation
            </button>

            <div className="mts_hero_img_wrap">
              <img
                src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777531982/heroNew_odhuda.webp"
                alt="Metaverse Development Company"
                loading="lazy"
              />
            </div>
          </div>
        </article>

        <div className="mts_grad_outer">
          {/* about */}
          <article className="primary__landing-content-container">
            <div className="mts_abt mts_mb_120">
              <div className="row g-4 mts_abt_row">
                <div className="col-lg-6 metav_devop_div">
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750159835/about_aiaccx.webp"
                    alt="Metaverse Development Company"
                    loading="lazy"
                    className="mts_abt_img"
                  />
                </div>
                <div className="col-lg-6">
                  <h3 className="mts_subtitle">
                    <span className="mts_span">What is metaverse </span>
                    development?
                  </h3>
                  <p className="mts_subcontent">
                    Metaverse development is a virtual reality-based digital
                    universe development where users can engage with others and
                    experience a wide range of activities and environments. It
                    combines virtual reality, augmented reality, and other
                    immersive technologies to create a seamless and
                    interconnected virtual space
                  </p>
                </div>
              </div>
            </div>
          </article>

          {/* key  */}
          <article className="mts_key mts_mb_100">
            <div className="primary__landing-content-container ">
              <h3 className="mts_subtitle mts_key_title">
                <span className="mts_span">Key Elements of </span>
                Metaverse Development
              </h3>
              <p className="mts_subcontent text-center mt-3">
                Metaverse development relies on several crucial elements
              </p>

              <div className="row g-4 mts_key_row">
                <div className="col-lg-4 col-sm-6">
                  <div className="mts_key_card">
                    <img
                      src={require("../../../image/Metaverse/key_img_one.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                    />
                    <h5>Virtual Reality (VR) and Augmented Reality (AR)</h5>
                    <p>
                      Achieve broader exposure by being listed on popular
                      cryptocurrency tracking platforms, driving potential
                      investors and users to your project.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="mts_key_card">
                    <img
                      src={require("../../../image/Metaverse/key_img_two.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                    />
                    <h5>Interoperability and Standardization</h5>
                    <p>
                      Interoperability ensures that different virtual worlds and
                      platforms within the Metaverse can seamlessly interact and
                      exchange information. Standardization establishes common
                      protocols and guidelines for consistent user experiences
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="mts_key_card">
                    <img
                      src={require("../../../image/Metaverse/key_img_three.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                    />
                    <h5>Blockchain and Cryptocurrency Integration</h5>
                    <p>
                      Blockchain technology and cryptocurrencies play a vital
                      role in the Metaverse by enabling secure transactions,
                      digital asset ownership, and decentralized governance
                    </p>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="mts_btn mt-4"
                >
                  Get Quote
                </button>
              </div>
            </div>
          </article>

          {/* use cases */}
          <article className="mts_use mts_mb_100">
            <div className="primary__landing-content-container">
              <h3 className="mts_subtitle mts_use_title">
                <span className="mts_span">Applications and Use </span>
                Cases of the Metaverse
              </h3>
              <p className="mts_subcontent text-center mt-3">
                The Metaverse offers a wide range of applications and use cases,
                including
              </p>

              <div className="mts_stack_outer">
                <AnimatePresence initial={false}>
                  {cards.map((card, i) => (
                    <motion.div
                      key={card.id}
                      className={`mts_stack_card ${classNames[i]}`}
                      initial={{ opacity: 0, scale: 0.9, y: 50 }}
                      animate={{ opacity: 1, scale: 1, y: 0 }}
                      exit={{ opacity: 0, scale: 0.95, y: -30 }}
                      transition={{ duration: 0.7, ease: "easeInOut" }}
                    >
                      <div className="row g-4">
                        <div className="col-lg-6">
                          <div className="mts_stack_lft">
                            <span>{card.id}</span>
                            <div className="mts_stack_cnt">
                              <h5>{card.title}</h5>
                              <p>{card.desc}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 text-center">
                          <img
                            src={card.img}
                            alt="Metaverse Development Company"
                            loading="lazy"
                            className="mts_use_img"
                          />
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </AnimatePresence>

                <div className="mts_st_btn_wrap">
                  <button className="mts_st_btn" onClick={handlePrev}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48 40"
                      fill="none"
                      preserveAspectRatio="xMidYMid meet"
                      aria-hidden="true"
                      role="img"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 3C16 1.34315 17.3431 0 19 0H21C22.6569 0 24 1.34315 24 3V5C24 6.65685 22.6569 8 21 8H18.4142C17.7739 8 17.1599 8.25435 16.7071 8.70711C16.2544 9.15986 16 9.77392 16 10.4142V13C16 14.6569 17.3431 16 19 16H45C46.6569 16 48 17.3431 48 19V21C48 22.6569 46.6569 24 45 24H19C17.3431 24 16 25.3431 16 27V29.5858C16 30.2261 16.2544 30.8401 16.7071 31.2929C17.1599 31.7456 17.7739 32 18.4142 32H21C22.6569 32 24 33.3431 24 35V37C24 38.6569 22.6569 40 21 40H19C17.3431 40 16 38.6569 16 37V34.4142C16 33.7739 15.7456 33.1599 15.2929 32.7071C14.8401 32.2544 14.2261 32 13.5858 32H11C9.34315 32 8 30.6569 8 29V26.4142C8 25.7739 7.74565 25.1599 7.29289 24.7071C6.84014 24.2544 6.22607 24 5.58578 24H3C1.34315 24 0 22.6569 0 21V19C0 17.3431 1.34315 16 3 16H5.58578C6.22607 16 6.84014 15.7456 7.29289 15.2929C7.74565 14.8401 8 14.2261 8 13.5858V11C8 9.34315 9.34315 8 11 8H13.5858C14.2261 8 14.8401 7.74565 15.2929 7.29289C15.7456 6.84014 16 6.22607 16 5.58578V3Z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                  <button className="mts_st_btn" onClick={handleNext}>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48 40"
                      fill="none"
                      preserveAspectRatio="xMidYMid meet"
                      aria-hidden="true"
                      role="img"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32 3C32 1.34315 30.6569 0 29 0H27C25.3431 0 24 1.34315 24 3V5C24 6.65685 25.3431 8 27 8H29.5858C30.2261 8 30.8401 8.25435 31.2929 8.70711C31.7456 9.15986 32 9.77393 32 10.4142V13C32 14.6569 30.6569 16 29 16H3C1.34315 16 0 17.3431 0 19V21C0 22.6569 1.34315 24 3 24H29C30.6569 24 32 25.3431 32 27V29.5858C32 30.2261 31.7456 30.8401 31.2929 31.2929C30.8401 31.7456 30.2261 32 29.5858 32H27C25.3431 32 24 33.3431 24 35V37C24 38.6569 25.3431 40 27 40H29C30.6569 40 32 38.6569 32 37V34.4142C32 33.7739 32.2544 33.1599 32.7071 32.7071C33.1599 32.2544 33.7739 32 34.4142 32H37C38.6569 32 40 30.6569 40 29V26.4142C40 25.7739 40.2544 25.1599 40.7071 24.7071C41.1599 24.2544 41.7739 24 42.4142 24H45C46.6569 24 48 22.6569 48 21V19C48 17.3431 46.6569 16 45 16H42.4142C41.7739 16 41.1599 15.7456 40.7071 15.2929C40.2544 14.8401 40 14.2261 40 13.5858V11C40 9.34315 38.6569 8 37 8H34.4142C33.7739 8 33.1599 7.74565 32.7071 7.29289C32.2544 6.84014 32 6.22607 32 5.58579V3Z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </article>

          <span className="mts_abt_grad"></span>
          <span className="mts_abt_grad_two"></span>
        </div>

        <div className="mts_grad_outer">
          {/* benefits */}
          <article className="primary__landing-content-container">
            <div className="mts_ben mts_mb_150">
              <h3 className="mts_subtitle mts_ben_title">
                <span className="mts_span">Advantages and Benefits </span>
                of the Metaverse
              </h3>
              <p className="mts_subcotent text-center mt-3">
                The Metaverse offers numerous advantages and benefits, including
              </p>

              <div className="row mts_ben_row">
                <div className="col-lg-4 mts_ben_card mts_ben_one">
                  <img
                    src={require("../../../image/Metaverse/ben_img_one.webp")}
                    alt="Metaverse Development Company"
                    loading="lazy"
                  />
                  <h5>Immersive and Engaging Experiences</h5>
                  <p>
                    Users can enter immersive environments and engage with
                    content in ways that surpass traditional digital experiences
                  </p>
                </div>
                <div className="col-lg-4 mts_ben_card ">
                  <img
                    src={require("../../../image/Metaverse/ben_img_two.webp")}
                    alt="Metaverse Development Company"
                    loading="lazy"
                  />
                  <h5>Global Collaboration and Connectivity</h5>
                  <p>
                    The Metaverse connects people from around the world,
                    fostering collaboration, cultural exchange, and shared
                    experiences
                  </p>
                </div>
                <div className="col-lg-4 mts_ben_card mts_ben_three">
                  <img
                    src={require("../../../image/Metaverse/ben_img_three.webp")}
                    alt="Metaverse Development Company"
                    loading="lazy"
                  />
                  <h5>New Economic Opportunities</h5>
                  <p>
                    The Metaverse creates a new digital economy, allowing users
                    to monetize their skills, creations, and virtual assets.
                    Personalized and Customizable Environments
                  </p>
                </div>
              </div>
            </div>
          </article>

          {/* challenges */}
          <article className="primary__landing-content-container">
            <div className="mts_challenges mts_mb_150">
              <h3 className="mts_subtitle text-center">
                <span className="mts_span">Challenges </span>
                and Considerations
              </h3>
              <p className="mts_subcontent text-center">
                Metaverse development faces several challenges and
                considerations, such as
              </p>

              <div className="row g-4 mts_challenge_row">
                <div className="col-lg-4 col-sm-6">
                  <div className="mts_ch_card">
                    <img
                      src={require("../../../image/Metaverse/ch_img_one.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                      className="mts_cd_img"
                    />
                    <h5>Privacy and Security</h5>
                    <p>
                      Protecting user data, ensuring privacy, and preventing
                      unauthorized access are critical considerations in
                      Metaverse development
                    </p>
                    <img
                      src={require("../../../image/Metaverse/ch_bg.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                      className="mts_ch_bg"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="mts_ch_card">
                    <img
                      src={require("../../../image/Metaverse/ch_img_two.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                      className="mts_cd_img"
                    />
                    <h5>Accessibility and Inclusivity</h5>
                    <p>
                      Ensuring that the Metaverse is accessible to people with
                      disabilities and inclusive of diverse populations is
                      essential for widespread adoption
                    </p>
                    <img
                      src={require("../../../image/Metaverse/ch_bg.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                      className="mts_ch_bg"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="mts_ch_card">
                    <img
                      src={require("../../../image/Metaverse/ch_img_three.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                      className="mts_cd_img"
                    />
                    <h5>Ethical and Regulatory Concerns</h5>
                    <p>
                      Developers and stakeholders must address ethical
                      considerations, such as digital rights, virtual identity,
                      and content moderation. Regulatory frameworks may need to
                      adapt to the unique aspects of the Metaverse
                    </p>
                    <img
                      src={require("../../../image/Metaverse/ch_bg.webp")}
                      alt="Metaverse Development Company"
                      loading="lazy"
                      className="mts_ch_bg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </article>

          <span className="mts_ben_grad"></span>
        </div>

        {/* future */}
        <article className="primary__landing-content-container">
          <div className="mts_future mts_mb_80">
            <h3 className="mts_subtitle text-center">
              <span className="mts_span">The Future </span> of the Metaverse
            </h3>
            <p className="mts_subcontent mts_future_cnt">
              The future of the Metaverse holds immense potential for innovation
              and growth. As technology advances, we can expect more immersive
              experiences, enhanced interconnectivity, and greater integration
              of the physical and virtual worlds
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="mts_btn mt-4"
              >
                Talk with Our Experts
              </button>
            </div>

            <div className="mts_future_img_wrap">
              <img
                src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750159834/future_bgr78r.webp"
                alt="Metaverse Development Company"
                loading="lazy"
              />
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta ml-mt-0">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Conclusion
            </h5>
            <p className="custom-get-content dt-get-content">
              Metaverse development represents a paradigm shift in how we engage
              with digital experiences. By leveraging virtual reality, augmented
              reality, blockchain
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Schedule a Free Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      <ServiceFooter />
    </>
  );
};

export default Metaverse;
